import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Fired when the proactive save-as-a-skill suggestion card is shown to the user',
  name: 'skill_save_suggestion_shown',
};

export default META;
